import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import StorefrontAboutSection from './StorefrontAboutSection.jsx';
import StorefrontMediaSection from './StorefrontMediaSection.jsx';
import StorefrontFeaturedSection from './StorefrontFeaturedSection.jsx';
import StorefrontCreatorsUrls from './StorefrontCreatorsUrls.jsx';

import { useShowSellerSince } from '../../utils/useShowSellerSince.ts';

import { useClientState } from 'dibs-react-hooks/exports/useClientState.ts';

function StorefrontHome({ seller, storefrontData, sellerData, isPreview, isTrade, user, viewer }) {
    const isClient = useClientState();
    const showSellerSince = useShowSellerSince({ viewer, seller });

    return (
        <>
            {/* About {Seller} */}
            <StorefrontAboutSection
                seller={seller}
                sellerData={sellerData}
                showSellerSince={showSellerSince}
            />

            {/* Featured Pieces */}
            {storefrontData?.edges?.length ? (
                <StorefrontFeaturedSection
                    isPreview={isPreview}
                    seller={seller}
                    isTrade={isTrade}
                    user={user}
                    viewer={viewer}
                    products={storefrontData}
                />
            ) : null}

            {/* Media Section */}
            <StorefrontMediaSection seller={seller} />

            {/* Creators URLs */}
            {isClient && <StorefrontCreatorsUrls featuredCreatorsUrls={storefrontData} />}
        </>
    );
}

StorefrontHome.propTypes = {
    isTrade: PropTypes.bool,
    isPreview: PropTypes.bool.isRequired,
    sellerData: PropTypes.shape({
        dealerSince: PropTypes.string.isRequired,
    }).isRequired,

    // fetched data
    user: PropTypes.object,
    viewer: PropTypes.object.isRequired,
    seller: PropTypes.object.isRequired,
    products: PropTypes.object,
    creatorsUrls: PropTypes.object,
    storefrontData: PropTypes.object,
};

export default createFragmentContainer(StorefrontHome, {
    viewer: graphql`
        fragment StorefrontHome_viewer on Viewer {
            ...StorefrontFeaturedSection_viewer
            ...useShowSellerSince_viewer
        }
    `,
    user: graphql`
        fragment StorefrontHome_user on User {
            ...StorefrontFeaturedSection_user
        }
    `,
    seller: graphql`
        fragment StorefrontHome_seller on Seller {
            ...StorefrontAboutSection_seller
            ...StorefrontMediaSection_seller
            ...StorefrontFeaturedSection_seller
            ...useShowSellerSince_seller
        }
    `,
    storefrontData: graphql`
        fragment StorefrontHome_storefrontData on DealerStorefrontQueryConnection {
            edges {
                __typename
            }
            ...StorefrontFeaturedSection_products
            ...StorefrontCreatorsUrls_featuredCreatorsUrls
        }
    `,
});
